module.exports = __webpack_public_path__ + "img/edge_activites_loisir.a9d65be6.svg";